import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import {
  Card,
  Grid,
  FormControl,
  InputLabel,
  InputAdornment,
  IconButton,
  FormHelperText,
  FormControlLabel,
  Checkbox,
  Button,
  FilledInput,
  Typography,
  makeStyles,
  useTheme,
} from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import SaveIcon from '@material-ui/icons/Save';
import { useSelector, useDispatch } from 'react-redux';
import { userActions } from '../../actions';
import { validation } from '../../helpers';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
const useStyle = makeStyles((theme) => ({
  card: {
    borderRadius: 8,
    border: `1px solid ${theme.palette.grey.main}`,
    padding: theme.spacing(4),
  },
  title: {
    fontWeight: 'bold',
  },
  marginBetweenInputs: {
    margin: theme.spacing(2, 0),
  },
  titleCentral: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginBottom: theme.spacing(1),
  },
  notification: {
    marginBottom: theme.spacing(2),
  },
  notificationMe: {
    fontSize: 12.8,
    fontWeight: 'bold',
  },
  btnSave: {
    float: 'right',
    textTransform: 'lowercase',
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
      fontWeight: 600,
    },
  },
}));

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
function UserSettings() {
  const [showPassword, setShowPassword] = useState(false);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const classes = useStyle();
  const { t } = useTranslation();
  const theme = useTheme();

  const { handleSubmit, register, errors, control } = useForm({
    mode: 'onBlur',
    defaultValues: {
      notificationAccepted: {
        email: user?.notificationAccepted?.email,
        sms: user?.notificationAccepted?.sms,
        _id: user?.notificationAccepted?._id,
      },
      notificationTrigger: {
        ideaApproved: user?.notificationTrigger?.ideaApproved
          ? user?.notificationTrigger?.ideaApproved
          : false,
        ideaComment: user?.notificationTrigger?.ideaComment
          ? user?.notificationTrigger?.ideaComment
          : false,
        ideaUpped: user?.notificationTrigger?.ideaUpped
          ? user?.notificationTrigger?.ideaUpped
          : false,
        ideaConcluded: user?.notificationTrigger?.ideaConcluded
          ? user?.notificationTrigger?.ideaConcluded
          : false,
        creditedPointIdea: user?.notificationTrigger?.creditedPointIdea
          ? user?.notificationTrigger?.creditedPointIdea
          : false,
        finishExecutionPending: user?.notificationTrigger?.finishExecutionPending
          ? user?.notificationTrigger?.finishExecutionPending
          : false,
        awaitingQualificationIdeas: user?.notificationTrigger?.awaitingQualificationIdeas
          ? user?.notificationTrigger?.awaitingQualificationIdeas
          : false,
        _id: user?.notificationTrigger?._id,
      },
    },
  });

  function handleClickTogglePassword() {
    setShowPassword(!showPassword);
  }

  function onSubmit(data) {
    if (data.password) {
      user.newPassword = data.password;
      user.password = data.password;
      user.confirmPassword = data.confirmPassword;
    }

    const notificationAccepted = {
      ...user.notificationAccepted,
      ...data.notificationAccepted,
    };

    const notificationTrigger = {
      ...user.notificationTrigger,
      ...data.notificationTrigger,
    };

    user.notificationAccepted = notificationAccepted;
    user.notificationTrigger = notificationTrigger;

    dispatch(userActions.updateUser(user));
  }
  function handleProfileType(perfil) {
    switch (capitalizeFirstLetter(perfil)) {
      case "Administrador":
        return []
      case "Colaborador":
        return [{
          label: 'pontos_creditados_pela_conclusao_da_ideia',
          name: 'notificationTrigger.creditedPointIdea'
        }]
      case "Gestor":
        return [{
          label: 'ideias_que_estao_em_execucao',
          name: 'notificationTrigger.finishExecutionPending'
        },
        {
          label: 'ideias_aguardando_qualificacao',
          name: 'notificationTrigger.awaitingQualificationIdeas'
        }]
      default:
        return []
    }
  }

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* prop office365 fake */}
        {user.office365 && (
          <div>
            <Typography
              variant="subtitle1"
              className={clsx(classes.title, classes.marginBetweenInputs)}
            >
              {t('alterar_senha')}
            </Typography>
            <div
              className={classes.marginBetweenInputs}
              style={{ fontSize: '1rem' }}
            >
              {t('informe_uma_senha_exclusiva_para_proteger_a_sua_conta')}.
            </div>
            <FormControl
              variant="filled"
              error={!!errors.password}
              className={classes.marginBetweenInputs}
            >
              <InputLabel htmlFor="password">{t('senha')}</InputLabel>
              <FilledInput
                id="password"
                type={showPassword ? 'text' : 'password'}
                name="password"
                inputRef={register({
                  validate: {
                    goodPassword: (value) =>
                      validation.goodPassword(value) ||
                      t('senha_invalida_verifique_as_instrucoes_abaixo'),
                  },
                })}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickTogglePassword}
                      edge="end"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
                disableUnderline
              />
              <FormHelperText id="helper-password">
                {errors.password && errors.password.message}
              </FormHelperText>
            </FormControl>
            <div>
              <div style={{ color: theme.palette.neutrals.low.medium, fontWeight: 600 }}>
                {t('sua_senha_deve_possuir')}:
              </div>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <li>
                  - {t('no_minimo')} 8 {t('caracteres')}
                </li>
                <li>
                  - {t('possuir')} 1 {t('caractere_especial')}
                </li>
              </ul>
            </div>{' '}
            *
          </div>
        )}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle1" className={classes.titleCentral}>
              {t('central_de_notificacoes')}
            </Typography>
          </Grid>          

          <Grid item xs={12}>
            <Card elevation={0} className={classes.card}>
              <Controller
                as={
                  <FormControlLabel
                    control={<Checkbox color="primary" />}
                    label={t('desejo_receber_as_notificacoes_por_email')}
                    style={{ width: '100%' }}
                  />
                }
                name="notificationAccepted.email"
                inputRef={register}
                control={control}
                className={classes.notification}
              />

              <div className={classes.notificationMe}>
                {t('me_notifique_quando').toUpperCase()} ...
              </div>
              <Controller
                as={
                  <FormControlLabel
                    control={<Checkbox color="primary" />}
                    label={t('alguma_ideia_minha_for_aprovada')}
                    style={{ width: '100%' }}
                  />
                }
                name="notificationTrigger.ideaApproved"
                inputRef={register}
                control={control}
                className={clsx(classes.notification, classes.borderBottom)}
              />

              <Controller
                as={
                  <FormControlLabel
                    control={<Checkbox color="primary" />}
                    label={t('alguem_der_um_up_em_uma_ideia_minha')}
                    style={{ width: '100%' }}
                  />
                }
                name="notificationTrigger.ideaUpped"
                inputRef={register}
                control={control}
                className={clsx(classes.notification, classes.borderBottom)}
              />

              <Controller
                as={
                  <FormControlLabel
                    control={<Checkbox color="primary" />}
                    label={t('alguem_comentar_uma_ideia_minha')}
                    style={{ width: '100%' }}
                  />
                }
                name="notificationTrigger.ideaComment"
                inputRef={register}
                control={control}
                className={clsx(classes.notification, classes.borderBottom)}
              />
              <Controller
                as={
                  <FormControlLabel
                    control={<Checkbox color="primary" />}
                    label={t('alguma_ideia_for_concluida')}
                    style={{ width: '100%' }}
                  />
                }
                name="notificationTrigger.ideaConcluded"
                inputRef={register}
                control={control}
                className={clsx(classes.notification, classes.borderBottom)}
              />
              {
                handleProfileType(user.typeProfile.description)?.map((item) => (
                  <Controller
                    as={
                      <FormControlLabel
                        control={<Checkbox color="primary" />}
                        label={t(`${item.label}`)}
                        style={{ width: '100%' }}
                      />
                    }
                    name={item.name}
                    inputRef={register}
                    control={control}
                    className={clsx(classes.notification, classes.borderBottom)}
                  />
                ))
              }

              <Button
                variant="contained"
                color="primary"
                type="submit"
                startIcon={<SaveIcon />}
                className={classes.btnSave}
              >
                {t('salvar_configuracoes')}
              </Button>
            </Card>
          </Grid>
        </Grid>
      </form>
    </div>
  );
}

export { UserSettings };
